import "./index.css";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { TooltipHost } from "office-ui-fabric-react/lib-commonjs/Tooltip";
import { DefaultButton, PrimaryButton } from "office-ui-fabric-react/lib-commonjs/Button";
import {
  bulkAddRemoveToolEditSwitch,
  chambersAutoEmpty,
  chambersAutofill,
  clearRulersOnScreen,
  endCapsAutoAdd,
  switchDrawingSelectorMode,
  switchToAddMode,
  switchToInletManifoldMode,
  switchToInsertaTeeMode,
  switchToInspectionPortMode,
  switchToOutletManifoldMode,
  switchToRemoveMode
} from "../../../actions/drawingtoolbar-actions";
import {
  CHAMBER_ACCESSORY_ID_INSERTA_TEE,
  CHAMBER_ACCESSORY_ID_INSPECTION_PORT,
  GLOBAL_DRAWING_MODE_ADD,
  GLOBAL_DRAWING_MODE_INLET_MANIFOLD,
  GLOBAL_DRAWING_MODE_INSERTA_TEE,
  GLOBAL_DRAWING_MODE_INSPECTION_PORT,
  GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD,
  GLOBAL_DRAWING_MODE_REMOVE,
  GLOBAL_DRAWING_SELECTOR_MODE_DEFAULT,
  GLOBAL_DRAWING_SELECTOR_MODE_DIRECT,
  GLOBAL_PROJECT_TYPE_CHAMBER,
  INLET_MANIFOLD_ID,
  MSG_INVALID_DRAWING_MODE_ERROR,
  OUTLET_MANIFOLD_ID
} from "../../../lib/types";
import PopUpHelper from "../../Calculations/popUpHelper.component";
import {
  cleanChambersByArrayIsolator,
  cleanChambersByManifoldMainRowArray,
  cleanChambersByManifoldVoidArray,
  deactivate,
  getChamberAccessoryMap,
  setChamberKeyValue,
  setInsertaTeeWarningType,
  showInsertaTeeWarning
} from "../../../actions/chamber-actions";
import { languageIds } from "../../../lib/localization/languageIds";
import { getRequiredChamberSlotsForTwoEndcaps } from "../../../lib/chamberBed/utils";
import ManifoldSelectors from "../../../reducers/main-manifold-reducer";
import { clearMainManifoldsState, removeMainManifoldsByArrayOfId } from "../../../actions/manifold-actions";
import Dialog, { DialogFooter, DialogType } from "office-ui-fabric-react/lib-commonjs/Dialog";
import { closeDialog } from "../../../actions/submit-dialog-actions";
import { setChamberAccesory } from "../../../actions/floating-tool-actions";
import { removeManifold } from "../../../actions/manifold-entry-actions";
import { floatingToolInsertaTeeClose, floatingToolInsertaTeeOpen } from "../../../actions/floating-tool-inserta-tee-actions";

class ComponentsComponent extends PureComponent{
  state = {
    aqua: true,
    coral: true,
    greenyellow: true,
    cornflowerblue: true,
    showChambersAutofillModal: false
  };

  showChambersAutofillModal = () => {
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    this.setState({ showChambersAutofillModal: true });
  };

  hideChambersAutofillModal = () => {
    this.setState({ showChambersAutofillModal: false });
  };

  showChambersAutofillModalText = () => {
    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_REMOVE:
        return this.props.content[this.props.lang].thisWillRemoveChambers;
      case GLOBAL_DRAWING_MODE_ADD:
        return this.props.content[this.props.lang].thisWillFillChambers;
      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
  };

  handleChambersAutofillEmptyClick = () => {
    this.hideChambersAutofillModal();
    let manifoldsArray = this.props.mainManifolds;
    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_REMOVE:
        if (manifoldsArray && manifoldsArray.length > 0) {
          this.props.clearMainManifoldsState();
          manifoldsArray
            .forEach(manifold => {
              this.props.cleanChambersByManifoldVoidArray(manifold._id, manifold._letRow, manifold._letColumn);
              this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);
              this.props.cleanChambersByArrayIsolator(manifold._id, manifold._letRow, manifold._letColumn);
              // TODO Here need to be added an upper and lower _cap_accesory
            });
          this.props.removeMainManifoldsByArrayOfId(manifoldsArray);
        }
        this.props.chambersAutoEmpty();
        break;
      case GLOBAL_DRAWING_MODE_ADD:
        manifoldsArray = ManifoldSelectors.getInnerManifoldIds();
        if (manifoldsArray && manifoldsArray.length > 0) {
          this.props.removeMainManifoldsByArrayOfId(manifoldsArray);
          manifoldsArray
            .forEach(manifold => {
              this.props.deactivate(manifold._letRow, manifold._letColumn);
              this.props.cleanChambersByManifoldVoidArray(manifold._id, manifold._letRow, manifold._letColumn);
              this.props.cleanChambersByManifoldMainRowArray(manifold._id, manifold._letRow, manifold._letColumn);
              this.props.cleanChambersByArrayIsolator(manifold._id, manifold._letRow, manifold._letColumn);
            });
        }
        this.props.chambersAutofill();
        break;
      case GLOBAL_DRAWING_MODE_INSERTA_TEE:
      case GLOBAL_DRAWING_MODE_INSPECTION_PORT:
      case GLOBAL_DRAWING_MODE_INLET_MANIFOLD:
      case GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD:
        break;
      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
  };

  handleEndCapsAutoAddRemoveClick() {
    const requiredChamberSlotsforTwoEndcaps = getRequiredChamberSlotsForTwoEndcaps(this.props.chamberEndCapType.length, this.props.chamberType.length);

    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_ADD:
        this.props.endCapsAutoAdd(requiredChamberSlotsforTwoEndcaps);
        break;
      case GLOBAL_DRAWING_MODE_INSERTA_TEE:
      case GLOBAL_DRAWING_MODE_INSPECTION_PORT:
      case GLOBAL_DRAWING_MODE_INLET_MANIFOLD:
      case GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD:
        break;
      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
  }

  handleAddModeClick() {
    this.props.switchToAddMode();
  }

  handleRemoveModeClick() {
    this.props.switchToRemoveMode();
  }

  handleInsertaTeeModeClick() {
    this.props.switchToInsertaTeeMode();
  }

  handleInspectionPortModeClick() {
    this.props.switchToInspectionPortMode();
  }

  handleInletManifoldModeClick() {
    this.props.switchToInletManifoldMode();
  }

  handleOutletManifoldModeClick() {
    this.props.switchToOutletManifoldMode();
  }

  handleBulkAddRemoveClick() {
    this.props.bulkAddRemoveToolEditSwitch(this.props.bulkAddRemoveToolEdit);
  }

  getDrawingModeChambersButtonLetter() {
    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_ADD:
        return this.props.content[this.props.lang].autofillChambers;
      case GLOBAL_DRAWING_MODE_REMOVE:
        return this.props.content[this.props.lang].autoRemoveChambers;
      case GLOBAL_DRAWING_MODE_INSERTA_TEE:
      case GLOBAL_DRAWING_MODE_INSPECTION_PORT:
      case GLOBAL_DRAWING_MODE_INLET_MANIFOLD:
      case GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD:
        return "-";
      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
  }

  getDrawingModeEndCapsButtonLetter() {
    switch (this.props.drawingMode) {
      case GLOBAL_DRAWING_MODE_ADD:
        return this.props.content[this.props.lang].autofillEndCaps;
      case GLOBAL_DRAWING_MODE_REMOVE:
        return this.props.content[this.props.lang].autoRemoveEndCaps;
      case GLOBAL_DRAWING_MODE_INSERTA_TEE:
      case GLOBAL_DRAWING_MODE_INSPECTION_PORT:
      case GLOBAL_DRAWING_MODE_INLET_MANIFOLD:
      case GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD:
        return "-";
      default:
        throw new Error(MSG_INVALID_DRAWING_MODE_ERROR);
    }
  }

  render() {
    const {
      lang,
      content,
      projectType
      // pipeAccessories,
    } = this.props;
    const { showChambersAutofillModal } = this.state;

    let buttonColor1 =
      this.getDrawingModeEndCapsButtonLetter() === "A" ? "blue" : "red";
    let buttonColor2 =
      this.getDrawingModeChambersButtonLetter() === "F" ? "blue" : "red";

    const getDesignModeFromId = id => {
      switch (id) {
        case CHAMBER_ACCESSORY_ID_INSERTA_TEE:
          return GLOBAL_DRAWING_MODE_INSERTA_TEE;
        case CHAMBER_ACCESSORY_ID_INSPECTION_PORT:
          return GLOBAL_DRAWING_MODE_INSPECTION_PORT;
        case INLET_MANIFOLD_ID:
          return GLOBAL_DRAWING_MODE_INLET_MANIFOLD;
        case OUTLET_MANIFOLD_ID:
          return GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD;
        default:
          return null;
      }
    };

    const changeColors = ( color ) => {
      this.setState({ [`${color}`]: !this.state[`${color}`] });
    };

    let selectors = [
      {
        text: content[lang].selectComponentChamber,
        drawingSelectorMode: GLOBAL_DRAWING_SELECTOR_MODE_DEFAULT
      },
      {
        text: content[lang].selectRowIsolatorRow,
        drawingSelectorMode: GLOBAL_DRAWING_SELECTOR_MODE_DIRECT
      }
    ];

    const buildSelectors = () => {
      return selectors.map(( item, index ) => {
        let style = {
          height: "100%",
          minHeight: "50px"
        };
        if (lang === languageIds.deDE && index === 0) {
          style.overflowWrap = "anywhere";
        }
        return (
          <div key={index}
               style={{ flexGrow: "1" }}
               className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">
            <DefaultButton
              text={item.text}
              label={item.text}
              className="borders"
              style={style}
              disabled={!this.props.chamberType}
              data-automation-id={item.drawingSelectorMode}
              primary={this.props.drawingSelectorMode === item.drawingSelectorMode}
              onClick={() => {
                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                this.props.switchToAddMode();
                this.props.switchDrawingSelectorMode(item.drawingSelectorMode);
              }}
            >
            </DefaultButton>
            <div />
          </div>
        );
      });
    };

    const buildAccessories = ( isStructuresSection ) => {
      return this.props.accessories
        .filter(accessory => {
          if (isStructuresSection)
            return accessory.name.toLowerCase().match(/( manifold)/g);
          return !accessory.name.toLowerCase().match(/(manifold)/g);
        })
        .map(accessory => {
          const drawingMode = getDesignModeFromId(accessory.id);
          let localizedName = isStructuresSection
            ? accessory.name.indexOf("Inlet") > -1 ? content[lang].inletStructureManifold : content[lang].outletStructureManifold
            : content[lang][( accessory.localeKey || accessory.name )];

          const isDisabled = ( this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT || !this.props.chamberType || this.ignoreAccessoryAttachment(accessory.id) );

          return (
            <div key={accessory.id} className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">
              <DefaultButton
                text={localizedName}
                label={localizedName}
                data-automation-id="add-mode"
                onMouseEnter={() => changeColors(accessory.color)}
                onMouseLeave={() => changeColors(accessory.color)}
                primary={this.props.drawingMode === drawingMode}
                className={!isDisabled ? "outline_grey_components_ads" : "disabled_grey_components_ads"}

                disabled={isDisabled}
                style={this.state[`${accessory.color}`] ? css[`${accessory.color}`] : css[`${accessory.color}Selected`]}

                onClick={() => {
                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  switch (accessory.id) {
                    case INLET_MANIFOLD_ID:
                      this.handleInletManifoldModeClick();
                      break;
                    case OUTLET_MANIFOLD_ID:
                      this.handleOutletManifoldModeClick();
                      break;
                    case CHAMBER_ACCESSORY_ID_INSERTA_TEE:
                      this.handleInsertaTeeModeClick();
                      break;
                    case CHAMBER_ACCESSORY_ID_INSPECTION_PORT:
                      this.handleInspectionPortModeClick();
                      break;
                    default:
                      break;
                  }
                }}>
              </DefaultButton>
              <div style={{ height: "10px" }} />
            </div>
          );
        });
    };

    const buildPipeAccessories = () => {
      return;
    };

    return (

      <React.Fragment>
        <div style={css.card}>
          <div className="Legend">
            <div
              className="content"
              ref={node => {
                this.legendNode = node;
              }}>
              {
                projectType === GLOBAL_PROJECT_TYPE_CHAMBER
                  ? (
                    <React.Fragment>
                      <div style={{ display: "flex" }} className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">{content[lang].addRemove}</div>
                      </div>
                      <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">
                          <TooltipHost
                            content={content[lang].addMode}
                            className="DawingToolbarTooltip"
                            calloutProps={{ gapSpace: 0 }}
                          >
                            <DefaultButton
                              primary={this.props.drawingMode === GLOBAL_DRAWING_MODE_ADD}
                              disabled={!this.props.chamberType}
                              data-automation-id="add-mode"
                              text={content[lang].addMode}
                              style={{ width: "100%" }}
                              onClick={() => {
                                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                                this.handleAddModeClick();
                              }}
                              className="borders"
                            />
                          </TooltipHost>
                          <div style={{ height: "10px" }} />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">
                          <TooltipHost
                            content={content[lang].removeMode}
                            className="DawingToolbarTooltip"
                            calloutProps={{ gapSpace: 0 }}
                          >
                            <DefaultButton
                              disabled={this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT || !this.props.chamberType}
                              className={
                                this.props.drawingMode === GLOBAL_DRAWING_MODE_REMOVE
                                  ? "RemoveRedButton borders"
                                  : "borders"
                              }
                              data-automation-id="remove-mode"
                              // iconProps={{ iconName: "Remove" }}
                              text={content[lang].removeMode}
                              onClick={() => {
                                this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                                this.handleRemoveModeClick();
                              }}
                              style={{ width: "100%" }}
                            />
                          </TooltipHost>
                          <div style={{ height: "10px" }} />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">
                          <TooltipHost
                            content={content[lang].addRemoveEndCaps}
                            calloutProps={{ gapSpace: 0 }}
                          >
                            {!this.props.chamberType ||
                            (
                              this.props.drawingMode === GLOBAL_DRAWING_MODE_ADD &&
                              this.props.drawingMode !== GLOBAL_DRAWING_MODE_REMOVE )
                              ? <DefaultButton
                                data-automation-id="autofill-empty"
                                disabled={!this.props.chamberType ||
                                  (
                                    this.props.drawingMode !== GLOBAL_DRAWING_MODE_ADD &&
                                    this.props.drawingMode !== GLOBAL_DRAWING_MODE_REMOVE
                                  )}
                                text={this.getDrawingModeEndCapsButtonLetter()}
                                className={"outline_grey_red_border_components_ads"}
                                onClick={() => {
                                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                                  this.handleEndCapsAutoAddRemoveClick();
                                }}
                              />
                              : null}

                          </TooltipHost>
                          <div style={{ height: "10px" }} />
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 ms-xxl6">
                          <TooltipHost
                            content={content[lang].autofillEmptyChambers}
                            calloutProps={{ gapSpace: 0 }}
                          >
                            <DefaultButton
                              data-automation-id="autofill-empty"
                              disabled={!this.props.chamberType ||
                                (
                                  this.props.drawingMode !== GLOBAL_DRAWING_MODE_ADD &&
                                  this.props.drawingMode !== GLOBAL_DRAWING_MODE_REMOVE
                                )}
                              className={"outline_grey_red_border_components_ads"}
                              text={this.getDrawingModeChambersButtonLetter()}
                              onClick={this.showChambersAutofillModal}
                            />
                          </TooltipHost>
                          <div style={{ height: "10px" }} />
                        </div>
                      </div>
                      {/* HIDING FOR CULTEC

                      <div style={{ display: "flex", paddingTop: "15px" }} className="ms-Grid-row">
                        <div
                          className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">{content[lang].selectionTools}</div>
                      </div>
                      <div className="ms-Grid-row" style={{ display: "flex" }}>
                        {buildSelectors()}
                      </div>*/}
                    </React.Fragment>
                  ) : null
              }
              {projectType === GLOBAL_PROJECT_TYPE_CHAMBER
                ? (
                  <React.Fragment>
                   {/* <div style={{ display: "flex", paddingTop: "15px" }} className="ms-Grid-row">
                      <div
                        className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">{content[lang].addRemoveStructures}</div>
                    </div>
                    <div className="ms-Grid-row">
                      {buildAccessories(true)}
                    </div>
                    <div style={{ display: "flex", paddingTop: "15px" }} className="ms-Grid-row">
                      <div
                        className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">{content[lang].addRemoveAccessories}</div>
                    </div>
                    <div className="ms-Grid-row">
                      {buildAccessories(false)}
                    </div>*/}
                  </React.Fragment>
                )
                : (
                  <React.Fragment>
                    <div style={{ display: "flex", paddingTop: "15px" }} className="ms-Grid-row">
                      <div
                        className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12">{content[lang].addRemoveAccessories}</div>
                    </div>
                    <div className="ms-Grid-row">
                      {buildPipeAccessories()}
                    </div>
                  </React.Fragment>
                )
              }
            </div>
          </div>
          {
            showChambersAutofillModal ? (
              <PopUpHelper
                type="alert"
                title={content[lang].proceed}
                show={showChambersAutofillModal}
                hideModal={this.hideChambersAutofillModal}
                text={this.showChambersAutofillModalText()}
                modalActions={this.handleChambersAutofillEmptyClick}
              /> ) : null
          }
        </div>

        <Dialog
          hidden={!this.props.insertaTeeWarning}
          dialogContentProps={{
            type: DialogType.normal,
            style: { minWidth: "450px" },
            titleId: "alert-level-title",
            title: content[lang].systemFunctionalityWarning,
            subText: content[lang].insertaTeeWarning
          }}
          modalProps={{ containerClassName: "alert-level-container" }}
          onDismiss={() => {
          }}
        >
          <DialogFooter>
            <div className="alert-level-input-container">
              <PrimaryButton onClick={() => {
                this.props.floatingToolInsertaTeeClose();
                const chamberAccessory = this.getChamberAccessoryTee("Inserta-tee");
                setTimeout(() => {
                  if (this.props.drawingMode === "GLOBAL_DRAWING_MODE_INSERTA_TEE") {
                    this.props.floatingToolInsertaTeeOpen(
                      this.props.insertaTeeValues.row,
                      this.props.insertaTeeValues.col,
                      chamberAccessory
                    );
                  }
                  this.props.showInsertaTeeWarning(false);
                  this.props.setInsertaTeeWarningType("");
                });
              }}
                             text={content[lang].continue} />
              <DefaultButton onClick={() => {
                // Remove manifold on cancel
                if (this.props.insertaTeeWarningType === "MANIFOLD_CREATE") {
                  const manifoldToRemove = ManifoldSelectors.getManifoldByIdFromMain(this.props.currentManifoldId);
                  this.props.removeManifold(manifoldToRemove);
                  this.props.cleanChambersByArrayIsolator(
                    manifoldToRemove._id,
                    manifoldToRemove._letRow,
                    manifoldToRemove._letColumn
                  );
                }
                if (this.props.insertaTeeWarningType === "SETTING_ISO") {
                  const manifoldToRemove = ManifoldSelectors.getManifoldByIdFromMain(this.props.currentManifoldId);
                  this.props.cleanChambersByArrayIsolator(
                    manifoldToRemove._id,
                    manifoldToRemove._letRow,
                    manifoldToRemove._letColumn
                  );
                }

                this.props.showInsertaTeeWarning(false);
                this.props.setInsertaTeeWarningType("");
              }}
                             text={content[lang].cancel}
                             className={"outline_grey_ads"} />
            </div>
          </DialogFooter>
        </Dialog>
      </React.Fragment>


    );
  }

  getChamberAccessoryTee( id ) {
    return this.props.getChamberAccessoryMap().get(id);
  }

  ignoreAccessoryAttachment( id ) {
    try {
      const accessory = this.props.getChamberAccessoryMap().get(id);
      const exception = accessory.exceptions[this.props.chamberType.id];
      if (exception && !exception.attachable) {
        return true;
      }
    } catch (exception) {
      console.warn("An issue occurred checking the accessory's exceptions", exception);
    }
    return false;
  }
}

const css = {
  card: {
    margin: "10px",
    height: "100%"
  },
  leftAlign: {
    textAlign: "left"
  },
  legendItem: {
    display: "flex",
    marginTop: "5px",
    marginBottom: "5px",
    alignItems: "center"
  },
  legendType: {
    width: "35px",
    height: "35px",
    marginRight: "10px",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat"
  },
  legendColor: {
    width: "25px",
    height: "25px",
    marginRight: "10px",
    border: "1px solid black"
  }
};

const mapStateToProps = ( state ) => {
  return {
    lang: state.localization.lang,
    content: state.localization.content,

    accessories: state.apptoolbar.accessories,
    pipeAccessories: state.apptoolbar.pipeAccessories,

    chamberType: state.globals.chamberType,
    drawingMode: state.globals.drawingMode,
    projectType: state.globals.projectType,
    enableDebuging: state.globals.enableDebuging,
    chamberEndCapType: state.globals.chamberEndCapType,
    drawingSelectorMode: state.globals.drawingSelectorMode,

    mainManifolds: state.mainManifolds.manifolds,

    insertaTeeWarning: state.chamberbed.insertaTeeWarning,
    insertaTeeWarningType: state.chamberbed.insertaTeeWarningType,
    insertaTeeValues: state.chamberbed.insertaTeeValues,
    currentManifoldId: state.manifoldEntry.manifoldId,

    isTeeDialogOpen: state.floatingToolInsertaTee.openDialog
  };
};

const mapDispatchToProps = {
  endCapsAutoAdd,
  switchToAddMode,
  chambersAutofill,
  chambersAutoEmpty,
  switchToRemoveMode,
  getChamberAccessoryMap,
  switchToInsertaTeeMode,
  switchDrawingSelectorMode,
  switchToInletManifoldMode,
  switchToInspectionPortMode,
  switchToOutletManifoldMode,
  bulkAddRemoveToolEditSwitch,
  clearRulersOnScreen,
  removeMainManifoldsByArrayOfId,
  setChamberKeyValue,
  deactivate,
  clearMainManifoldsState,
  cleanChambersByManifoldVoidArray,
  cleanChambersByArrayIsolator,
  cleanChambersByManifoldMainRowArray,
  showInsertaTeeWarning,
  closeDialog,
  setChamberAccesory,
  removeManifold,
  setInsertaTeeWarningType,
  floatingToolInsertaTeeOpen,
  floatingToolInsertaTeeClose
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ComponentsComponent);



// WEBPACK FOOTER //
// ./src/components/LeftMenu/Component/components.component.js